import { Service } from './service'

export class GiftMallService extends Service {
  loadGiftMallConfig () {
    return this._horizonRequestBuilder.giftmall()
      .init()
      .call()
  }

  /**
   * Order up the gift certificate
   *
   * @param $opts
   *  $certificate_value
   *  $organization_id
   *  $address
   * @return {ResponseBuilder}
   */
  preOrder ($opts) {
    return this._horizonRequestBuilder.giftmall()
      .orderCertificate()
      .setData($opts)
      .callPost(this._keypair)
  }
}

export const giftMallService = new GiftMallService()



// WEBPACK FOOTER //
// ./src/js/services/giftmall.service.js